import { useQuery } from "react-query";
import request from "@common/request";

const useHouseholdInvitations = (options = {}) =>
  useQuery(
    "householdInvitations",
    () =>
      request<Forme.HouseholdInvitation[]>("GET", "/api/me/household-invites"),
    options
  );

export { useHouseholdInvitations };
